<template>
  <div class="block-wrap">
    <div class="award-wrap">
      <div class="tabs-wrap">
        <div class="tab-item"
          v-for="(bar, index) in tabs"
          :key="index"
          @click="switchBar(index)"
          :class="activeIndex === index ? 'active' : ''" >
          <img class="tab-item-logo" :src="activeIndex === index ? bar.activityLogo : bar.logo" />
          <div class="tab-item-title">
            <h3>{{ bar.title }}</h3>
            <div class="title-desc">{{ bar.desc }}</div>
          </div>
        </div>
      </div>
      <component :is="componentName"
        :activityData="activityData"
        :list="awardList"
      ></component>
    </div>
  </div>
</template>

<script>
import hdjyL from '@/assets/images/hdjy_l.png';
import hdjyB from '@/assets/images/hdjy_b.png';
import pypjL from '@/assets/images/pypj_l.png';
import pypjB from '@/assets/images/pypj_b.png';
import Activity from './Activity.vue';
import Engineering from './Engineering.vue';
export default {
  props: {
    activityData: {
      type: Object,
      default: () => {}
    },
    awardList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      tabs: [{
        logo: pypjL,
        activityLogo: pypjB,
        title: '优质项目',
        desc: 'Award',
        component: 'Engineering',
      }, {
        logo: hdjyL,
        activityLogo: hdjyB,
        title: '活动剪影',
        desc: 'Activity silhouette',
        component: 'Activity',
      }]
    }
  },
  computed: {
    componentName() {
      return this.tabs[this.activeIndex].component;
    }
  },
  components: {
    Activity,
    Engineering
  },
  methods: {
    switchBar(id) {
      this.activeIndex = id;

    }
  }
}
</script>

<style lang="less" scoped>
.tabs-wrap {
  width: 100%;
  height: 100px;
  display: flex;

  .tab-item {
    flex: 1;
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 10px;
    background: url(../../assets/images/pypj_l_bg.png) no-repeat center 0;
    background-size: 100% 89px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;

    // &::after {
    //   content: '';
    //   position: absolute;
    //   top: 100%;
    //   width: 0px;
    //   height: 0px;
    //   border: 10px solid #000;
    //   border-top-color: transparent;
    //   border-bottom-color: transparent;
    //   border-left-color: transparent;
    //   border-right-color: transparent;
    // }

    &.active {
      background-size: 100% 100px;
      // &::after {
      //   border-top-color: #06AE63;
      // }

      &:first-child {
        background-image: url(../../assets/images/pypj_b_bg.png);
      }

      &:last-child {
        background-image: url(../../assets/images/hdjy_b_bg.png);
      }

      .tab-item-title {
        h3, .title-desc {
          color: #fff;
        }
      }
    }

    &-logo {
      display: block;
      width: 50px;
      height: 50px;
      margin-right: 18px;
    }

    &-title {
      margin-right: 72px;

      h3 {
        height: 35px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #131415;
        line-height: 35px;
      }

      .title-desc {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #131415;
        opacity: 0.2;
        line-height: 25px;
      }
    }
  }
}
</style>